export default [
  {
    path: '/analytics/user-activity',
    name: 'user-activity',
    meta: { title: 'User-Activity' },
    component: () => import('../views/analytics/user-activity.vue'),
  },
  {
    path: '/analytics/se-activity-individual',
    name: 'se-activity-individual-view',
    meta: { title: 'SE/CE-Activity-Individual-View' },
    component: () => import('../views/analytics/Individual-view-analytics.vue'),
  },
  {
    path: '/analytics/se-activity-department',
    name: 'se-activity-department-vew',
    meta: { title: 'SE/CE-Activity-Department-View' },
    component: () => import('../views/analytics/department-vew-analytics.vue'),
  },
  {
    path: '/analytics/content-details-view',
    name: 'content-details-view',
    meta: { title: 'Content-Details-View' },
    component: () => import('../views/analytics/content-details-view.vue'),
  },
  {
    path: '/analytics/quality',
    name: 'quality-review',
    meta: { title: 'Quality-Review' },
    component: () => import('../views/analytics/quality-review-analytics.vue'),
  },
  {
    path: '/analytics/se-certification',
    name: 'se-certification-view',
    meta: { title: 'SE/CE-Certification-View' },
    component: () =>
      import('../views/analytics/se-certification-analytics.vue'),
  },
  {
    path: '/analytics/top',
    name: 'top-content-view',
    meta: { title: 'Top-Content-View' },
    component: () => import('../views/analytics/top-content-view.vue'),
  },
  {
    path: '/analytics/hits',
    name: 'content-hits-view',
    meta: { title: 'Content-Hits-View' },
    component: () => import('../views/analytics/content-hits-view.vue'),
  },
]
